// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaViewListQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  offset?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  filter?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortBy?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortDirection?: Types.InputMaybe<Types.SortDirection>;
}>;

export type SchemaViewListQuery = {
  __typename?: "GraphqlQuery";
  getSchemaViews: Array<{
    __typename?: "SchemaView";
    id: string;
    schemaName: string;
    viewName: string;
    viewDefinition: string;
    materializedView: boolean;
    sizeBytes?: number | null;
    issues?: Array<{
      __typename?: "Issue";
      id: string;
      state: string;
      description: string;
      severity: string;
      references: Array<{ __typename?: "IssueReference"; name: string }>;
    } | null> | null;
  }>;
};

export const SchemaViewListDocument = gql`
  query SchemaViewList(
    $databaseId: ID!
    $offset: Int
    $limit: Int
    $filter: String
    $sortBy: String
    $sortDirection: SortDirection
  ) {
    getSchemaViews(
      databaseId: $databaseId
      offset: $offset
      limit: $limit
      filter: $filter
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      id
      schemaName
      viewName
      viewDefinition
      materializedView
      sizeBytes
      issues {
        id
        state
        description
        severity
        references {
          name
        }
      }
    }
  }
`;

/**
 * __useSchemaViewListQuery__
 *
 * To run a query within a React component, call `useSchemaViewListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaViewListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaViewListQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useSchemaViewListQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaViewListQuery,
    SchemaViewListQueryVariables
  > &
    (
      | { variables: SchemaViewListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SchemaViewListQuery, SchemaViewListQueryVariables>(
    SchemaViewListDocument,
    options,
  );
}
export function useSchemaViewListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaViewListQuery,
    SchemaViewListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SchemaViewListQuery, SchemaViewListQueryVariables>(
    SchemaViewListDocument,
    options,
  );
}
// @ts-ignore
export function useSchemaViewListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaViewListQuery,
    SchemaViewListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaViewListQuery,
  SchemaViewListQueryVariables
>;
export function useSchemaViewListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaViewListQuery,
        SchemaViewListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaViewListQuery | undefined,
  SchemaViewListQueryVariables
>;
export function useSchemaViewListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaViewListQuery,
        SchemaViewListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaViewListQuery,
    SchemaViewListQueryVariables
  >(SchemaViewListDocument, options);
}
export type SchemaViewListQueryHookResult = ReturnType<
  typeof useSchemaViewListQuery
>;
export type SchemaViewListLazyQueryHookResult = ReturnType<
  typeof useSchemaViewListLazyQuery
>;
export type SchemaViewListSuspenseQueryHookResult = ReturnType<
  typeof useSchemaViewListSuspenseQuery
>;
export type SchemaViewListQueryResult = Apollo.QueryResult<
  SchemaViewListQuery,
  SchemaViewListQueryVariables
>;
